import React from "react";
import { useNavigate } from "react-router-dom";
import { axiosput } from "../../helpers/httprequest";
import swal from "../../helpers/swal";
import { Link } from "react-router-dom";
import { Form, Formik } from "formik";
import { ms_applicant } from "@v2/validators";
import ErrorMessage from "../../components/ErrorMessage";

const Forgot = () => {
  const navigate = useNavigate();
  const _login = async (values) => {
    try {
      const uname = values.emailaddress;
      const req = await axiosput("ms_applicant/forgot", {
        emailaddress: uname,
      });
      if (req.status !== 200) {
        throw new Error("Sorry, system could not finish processing your request");
      }
      const { type, message } = req.data;
      if (type === "success") {
        swal(type, message);
        setTimeout(() => navigate("/"), 1000);
      }
      swal(type, message);
    } catch ({ message }) {
      swal("warning", message);
    }
  };
  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth px-0">
          <div className="row w-100 mx-0">
            <div className="col-lg-8 mx-auto">
              <div className="auth-form-light text-left py-3 px-4 px-sm-5">
                <div className="brand-logo text-center">
                  <img src="images/logo.png" alt="logo" />
                </div>
                <div className="text-center my-5 mt-5">
                  <h4>Kebbi State Polytechnic Dakingari</h4>
                  <h6 className="font-weight-light text-uppercase">Admission Application Portal</h6>
                  <h6 className="font-weight-light">RECOVER ACCOUNT PASSWORD</h6>
                </div>
                <Formik
                  initialValues={{
                    emailaddress: "",
                  }}
                  validationSchema={ms_applicant.forgetpasswordrules}
                  initialTouched={{ zip: true }}
                  onSubmit={_login}
                >
                  {({ isSubmitting, touched, errors }) => (
                    <Form className="my-4">
                      <div className="pt-3">
                        <ErrorMessage name={"emailaddress"} label="Email Address" errors={errors?.emailaddress} touched={touched?.emailaddress} />

                        <div className="mt-3">
                          <button type="submit" disabled={isSubmitting} className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn">
                            {isSubmitting ? "Please wait..." : "Recover Password"}
                          </button>
                        </div>
                        <div className="my-2 d-flex justify-content-between align-items-end">
                          <Link to="/" className="auth-link text-black">
                            Sign In?
                          </Link>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Forgot;
